var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"light":"","rounded":"","color":"primary","block":"","disabled":_vm.disabled},on:{"click":function($event){return _vm.onclick()}}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }